import { motion } from 'framer-motion'
import { formatTime } from '../../lib/utils'
import { BoatIndicator } from '../ui/BoatIndicator'

interface TickerItem {
  id: string
  pilotName: string
  boatNumber: number
  boatColor: string
  lapTime: number
}

interface TickerProps {
  items: TickerItem[]
  title?: string
}

export function Ticker({ items, title: _title = 'TODAY\'S BEST TIMES' }: TickerProps) {
  const extendedItems = [...items, ...items]

  return (
    <div className="fixed top-0 left-0 right-0 h-24 bg-transparent flex items-start pointer-events-none">
      <div className="w-full h-full flex items-center overflow-hidden">
        <motion.div
          animate={{ x: [0, -100] }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: 'linear',
          }}
          className="flex gap-4 whitespace-nowrap"
        >
          {extendedItems.map((item, index) => (
            <div
              key={`${item.id}-${index}`}
              className="flex items-center gap-3 bg-gradient-to-r from-tropical-green to-paradise-blue p-1 rounded-lg flex-shrink-0"
            >
              <div className="bg-palm-dark rounded-lg px-4 py-3 flex items-center gap-3 h-full">
                <div className="text-2xl font-fredoka font-700 text-tropical-green">
                  {formatTime(item.lapTime)}
                </div>

                <div className="w-px h-8 bg-tropical-green bg-opacity-30" />

                <div className="flex items-center gap-2">
                  <div className="text-sm font-fredoka font-600 text-sand-light">
                    {item.pilotName}
                  </div>
                  <BoatIndicator
                    boatNumber={item.boatNumber}
                    color={item.boatColor}
                    size="sm"
                  />
                </div>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  )
}
